import { render, staticRenderFns } from "./CollectionDepartmentPerformanceLock.vue?vue&type=template&id=3c4212ea&scoped=true"
import script from "./CollectionDepartmentPerformanceLock.vue?vue&type=script&lang=js"
export * from "./CollectionDepartmentPerformanceLock.vue?vue&type=script&lang=js"
import style0 from "./CollectionDepartmentPerformanceLock.vue?vue&type=style&index=0&id=3c4212ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4212ea",
  null
  
)

export default component.exports